<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
const customerId = window.localStorage.getItem("customerId");
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "management",
      id: "",
      selectC: "",
      url: {},
      items: [
        { label: "新建项目", type: "header" },
        {
          label: "父级项目",
          name: "parentId",
          value: "",
          type: "select",
          width: "400px",
          dropList: [],
          // onChange:this.onSelectParent
        },
        {
          label: "项目名称",
          name: "name",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true }],
        },
        {
          label: "金额(元)",
          name: "budget",
          value: "",
          type: "number",
          width: "400px",
          min: 1,
          max: 100000000,
          formatter: (value) => `¥ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
          parser: (value) => value.replace(/\¥\s?|(,*)/g, ""),
          rules: [{ required: true }],
        },
        {
          label: "适用流程",
          name: "scheduleId",
          value: "",
          type: "select",
          width: "400px",
          dropList: [],
          rules: [
            {
              required: true,
              message: "适用流程不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
        },
        {
          label: "项目类型",
          name: "projectType",
          value: "",
          type: "input",
          width: "400px",
        },
        {
          label: "开始时间",
          name: "beginTime",
          value: " ",
          type: "date",
          format: "yyyy年MM月dd日",
          rules: [{ required: true }],
        },
        {
          label: "结束时间",
          name: "endTime",
          value: " ",
          type: "date",
          format: "yyyy年MM月dd日",
          rules: [{ required: true }],
        },
        {
          label: "负责人",
          name: "projectLeader",
          value: "",
          type: "select",
          width: "400px",
          dropList: [],
          rules: [
            {
              required: true,
              message: "负责人不能为空",
              trigger: "blur",
              type: "number",
            },
          ],
        },
        {
          label: customerId == 0 ? "客户" : "供应商",
          name: "sysSupplierIds",
          value: "",
          type: "multiple",
          width: "400px",
          filterable: true,
          dropList: [],
        },
        { label: "备注", name: "remark", value: "", type: "textarea", width: "400px" },
      ],
      forms: {},
    };
  },
  created() {
    let query = this.$route.query;
    this.loadAdminUserData();
    this.scheduleIdData();
    this.parentListData();
    this.loadSupplierList()
    if (query.action == "edit") {
      this.id = query.id;
      this.initData();
    }
  },
  mounted() { },
  methods: {
    async loadSupplierList() {
      let q = {};
      let res = await $utils.api.load("/admin/system/supplier/list", q);
      if (res && res.rows) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.supplierName;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "sysSupplierIds") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
    async initData() {
      let id = this.id;
      if (id) {
        let res = await $utils.api.load(`/admin/system/management/get/${id}`);
        try {
          if (res) {
            this.forms = res.data;
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    async handleSubmit() {
      let q = this.forms;
      if (q.beginTime == " ") {
        $utils.toast.error("请选择开始时间");
        return
      }
      if (q.endTime == " ") {
        $utils.toast.error("请选择结束时间");
        return
      }
      await this.$refs.form.validate((valid) => {
        if (valid) {
          $utils.api
            .load(`/admin/system/management`, q, this.action == "edit" ? "PUT" : "POST")
            .then((res) => {
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    async loadAdminUserData() {
      let q = {};
      let res = await $utils.api.load("/admin/system/user/listPrincipal", q);
      if (res && res.rows) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.nickName;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "projectLeader") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
    async scheduleIdData() {
      let q = {};
      let res = await $utils.api.load("/admin/system/schedule/list", q);
      if (res && res.rows) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.workflowName;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "scheduleId") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
    async parentListData() {
      let q = {};
      let res = await $utils.api.load("/admin/system/management/parentList", q);
      if (res && res.data) {
        let ll = res.data;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.name;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "parentId") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
  },
};
</script>
